import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets.app/images/card-details-visa.svg'
import _imports_1 from '@/assets.app/images/card-details.svg'


const _hoisted_1 = {
  key: 0,
  class: "card-details"
}
const _hoisted_2 = {
  key: 0,
  class: "card-details__icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  class: "card-details__icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = { class: "card-details__item card-details__item--number" }
const _hoisted_5 = { class: "payment-card__unit" }
const _hoisted_6 = { class: "card-details__item card-details__item--expiration" }

import { BillingView } from '@/models/billing'


export default /*@__PURE__*/_defineComponent({
  __name: 'StripeCardInfo',
  props: {
    billing: {}
  },
  emits: ["change"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (__props.billing.card_data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.billing.card_data.brand === 'Visa')
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : (_openBlock(), _createElementBlock("img", _hoisted_3)),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"payment-card__unit\"><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i></div><div class=\"payment-card__unit\"><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i></div><div class=\"payment-card__unit\"><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i><i class=\"payment-card__unit-dot\"></i></div>", 3)),
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.billing.card_data.last4), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.billing.card_data.exp_month) + "/" + _toDisplayString(__props.billing.card_data.exp_year), 1),
        _createElementVNode("a", {
          class: "card-details__item card-details__item--edit",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change')))
        }, " edit ")
      ]))
    : _createCommentVNode("", true)
}
}

})